import "./HomePageCss/FAQSection.css";
import { useNavigate } from "react-router-dom";
import AnimatedText from "../../AnimatedText";

export default function FAQSectionSection() {
  const navigator = useNavigate();

  // FAQ categories
  const Qs = [
    { name: "General Queries" },
    { name: "Home Collection" },
    { name: "Diagnostic Test Information" },
    { name: "Payments" },
    { name: "Reports" },
    { name: "Contact and Support" },
  ];

  // Slug mapping (MUST be inside component)
  const slugMap = {
    "General Queries": "general",
    "Home Collection": "home-collection",
    "Diagnostic Test Information": "diagnostic",
    "Payments": "payments",
    "Reports": "reports",
    "Contact and Support": "contact",
  };

  // Click handler
  const handleLinkOn = (name) => {
    const slug = slugMap[name];
    navigator(`/faqs#${slug}`);
  };

  return (
    <>
      <div className="faqContainer">
        <div className="faqUpperSection">
          <AnimatedText tag="h1" type="words" y={30}>
            Frequently Asked Questions (FAQs)
          </AnimatedText>
        </div>

        <div className="questionsSection">
          {Qs.map((q, indx) => (
            <div
              className="qus"
              key={indx}
              onClick={() => handleLinkOn(q.name)}
            >
              <p>
                <span>+</span> {q.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}